import { useMutation, useQueryClient } from "@tanstack/react-query";
import { duplicateStory } from "../services/dataStories/storiesApi";
import { getApiErrorMessage } from "../services/apiErrors";
import { queryKeys } from "../services/queryKeys";
import { notify } from "../services/notify";
import { DUPLICATE_STORY_COPY } from "./useDuplicateStory.copy";

interface Args {
  /** Opens the copy (the toast's Open action). */
  onOpen: (storyId: string, workspaceId: string) => void;
}

/**
 * Copies a story (POST .../duplicate): refreshes the workspace's story list and toasts with an
 * Open action for the copy, or the API's error message. One hook for the list rows and the story header.
 */
export const useDuplicateStory = ({ onOpen }: Args) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (story: { id: string; workspaceId: string }) => duplicateStory(story.workspaceId, story.id),
    onSuccess: (created, story) => {
      queryClient.invalidateQueries({ queryKey: queryKeys.stories.list(story.workspaceId) });
      notify({
        kind: "success",
        title: DUPLICATE_STORY_COPY.done(created.title),
        action: { label: DUPLICATE_STORY_COPY.open, onClick: () => onOpen(created.id, story.workspaceId) },
      });
    },
    onError: (error) =>
      notify({
        kind: "error",
        title: DUPLICATE_STORY_COPY.failed,
        body: getApiErrorMessage(error, DUPLICATE_STORY_COPY.retry),
      }),
  });
};
